// components
import type { DialogActionsProps } from '@mui/material';
import { DialogActions, styled } from '@mui/material';

export const StyledFlexMatchSettingsDialogActions = styled(
  DialogActions
)<DialogActionsProps>(({ theme }) => ({
  // Rendered as a sibling of the dialog content (see the `actions` prop of the
  // shared Dialog), so it sits outside the scroll area: full width, hugging the
  // bottom of the dialog, and it can never overlap the content above it.
  flexShrink: 0,
  background: theme.palette.background.paper,

  '&&.MuiDialogActions-root': {
    padding: theme.spacing(4, 6)
  }
}));
